import React from 'react'
import AccordionTest from 'presentation/shared/components/AccordionTest'
import { ProcedurePendencyCard } from 'presentation/shared/components/ProcedurePendencyCard'
import { useState } from 'react'
import * as S from './styles'
import { PendenciesType, PendencyInfoType, PendencyTypes } from '../../types'
import { convertNameToTitleCase, getPendencyTitle } from '../../functions'
import { Profile } from 'common/enum/profile'
import { HistoricModel } from 'domain/usecases/surgical-pendency/load-surgical-pendency'

export type PendencyInfoProps = {
  pendencies: {
    surgical_pendency_id: number
    surgical_pendency_order_id: number
    status: string
    historic: HistoricModel[]
    surgical_pendency_parent_id: number
    responsible: string
    createdAt: string
    type?: PendencyTypes
  }[]
  setPendencyOrderId: any
  loadSurgicalPendency: any
}
export const PendenciesTab = ({
  pendencies,
  loadSurgicalPendency,
  setPendencyOrderId
}: PendenciesType) => {
  const items = [
    {
      title: (
        <TitlePendencyAccordion
          color={'#FF9E22'}
          total={pendencies?.pendent?.length || 0}
        >
          À resolver
        </TitlePendencyAccordion>
      ),
      content: (
        <PendenciesToSolveList
          pendencies={pendencies?.pendent}
          loadSurgicalPendency={loadSurgicalPendency}
          setPendencyOrderId={setPendencyOrderId}
        />
      )
    },
    {
      title: (
        <TitlePendencyAccordion
          color={'#B177E3'}
          total={pendencies?.in_progress?.length || 0}
        >
          Em andamento
        </TitlePendencyAccordion>
      ),
      content: (
        <PendenciesInProgress
          pendencies={pendencies?.in_progress}
          loadSurgicalPendency={loadSurgicalPendency}
          setPendencyOrderId={setPendencyOrderId}
        />
      )
    },
    {
      title: (
        <TitlePendencyAccordion
          color={'#28ABA1'}
          total={pendencies?.resolved?.length || 0}
        >
          Resolvidas
        </TitlePendencyAccordion>
      ),
      content: (
        <PendenciesSolved
          pendencies={pendencies?.resolved}
          loadSurgicalPendency={loadSurgicalPendency}
          setPendencyOrderId={setPendencyOrderId}
        />
      )
    }
  ]

  return (
    <S.AccordionsWrapper>
      <AccordionTest items={items} padding="0" />
    </S.AccordionsWrapper>
  )
}

const TitlePendencyAccordion = ({ color, total, children }: any) => {
  return (
    <S.AccordionContainer>
      <S.BallCounter color={color}>{total}</S.BallCounter>
      <span>{children}</span>
    </S.AccordionContainer>
  )
}

const PendenciesToSolveList = ({
  pendencies,
  loadSurgicalPendency,
  setPendencyOrderId
}: PendencyInfoProps) => {
  const [selectedCard, setSelectedCard] = useState('') as any

  function selectCard(index: number, surgicalPendency: PendencyInfoType) {
    setSelectedCard(index)
    loadSurgicalPendency(
      surgicalPendency.surgical_pendency_id,
      surgicalPendency.type
    )
    setPendencyOrderId(surgicalPendency.surgical_pendency_order_id)
  }

  return (
    <S.PendenciesWrapper>
      {pendencies?.map((item, index) => {
        const latestNonTimeline = item?.historic?.find((h) => !h.is_timeline)
        return (
          <div
            key={index}
            onClick={() => selectCard(index, item)}
            style={{ padding: '0 16px' }}
          >
            <ProcedurePendencyCard
              variant="orange"
              selected={selectedCard === index}
              title={getPendencyTitle(item)}
              description={
                item?.type === PendencyTypes.DOCTOR_COMMUNICATION
                  ? `Dr.(a) ${convertNameToTitleCase(
                      latestNonTimeline?.responsible || ''
                    )} enviou uma mensagem`
                  : `${
                      latestNonTimeline?.profile ===
                      Profile.DOCTOR.toUpperCase()
                        ? 'Dr.(a)'
                        : ''
                    }` +
                    ' ' +
                    (latestNonTimeline?.description ??
                      convertNameToTitleCase(
                        latestNonTimeline?.responsible || ''
                      ))
              }
              responsible={convertNameToTitleCase(item?.responsible)}
              createdAt={item?.createdAt}
              message={latestNonTimeline?.message || ''}
              status={'À resolver'}
              authorLastMessage={
                `${
                  latestNonTimeline?.profile === Profile.DOCTOR.toUpperCase()
                    ? 'Dr.(a)'
                    : ''
                }` +
                ' ' +
                convertNameToTitleCase(latestNonTimeline?.responsible || '')
              }
              dateLastMessage={latestNonTimeline?.createdAt}
            />
          </div>
        )
      })}
    </S.PendenciesWrapper>
  )
}

const PendenciesInProgress = ({
  pendencies,
  loadSurgicalPendency,
  setPendencyOrderId
}: PendencyInfoProps) => {
  const [selectedCard, setSelectedCard] = useState('') as any

  function selectCard(index: number, surgicalPendency: PendencyInfoType) {
    setSelectedCard(index)
    loadSurgicalPendency(
      surgicalPendency.surgical_pendency_id,
      surgicalPendency.type
    )
    setPendencyOrderId(surgicalPendency.surgical_pendency_order_id)
  }

  return (
    <S.PendenciesWrapper>
      {pendencies?.map((item, index) => {
        const latestNonTimeline = item?.historic?.find((h) => !h.is_timeline)
        return (
          <div
            key={index}
            onClick={() => selectCard(index, item)}
            style={{ padding: '0 16px' }}
          >
            <ProcedurePendencyCard
              variant="purple"
              selected={selectedCard === index}
              title={getPendencyTitle(item)}
              description={
                item?.type === PendencyTypes.DOCTOR_COMMUNICATION
                  ? `${convertNameToTitleCase(
                      latestNonTimeline?.responsible || ''
                    )} criou uma pendência:`
                  : latestNonTimeline?.description ??
                    convertNameToTitleCase(latestNonTimeline?.responsible || '')
              }
              responsible={item?.responsible}
              createdAt={item?.createdAt}
              message={latestNonTimeline?.message || ''}
              status={'Em andamento'}
              authorLastMessage={latestNonTimeline?.responsible}
              dateLastMessage={latestNonTimeline?.createdAt}
            />
          </div>
        )
      })}
    </S.PendenciesWrapper>
  )
}

const PendenciesSolved = ({
  pendencies,
  loadSurgicalPendency,
  setPendencyOrderId
}: PendencyInfoProps) => {
  const [selectedCard, setSelectedCard] = useState('') as any

  function selectCard(index: number, surgicalPendency: PendencyInfoType) {
    setSelectedCard(index)
    loadSurgicalPendency(
      surgicalPendency.surgical_pendency_id,
      surgicalPendency.type
    )
    setPendencyOrderId(surgicalPendency.surgical_pendency_order_id)
  }

  return (
    <S.PendenciesWrapper>
      {pendencies?.map((item, index) => {
        const latestNonTimeline = item?.historic?.find((h) => !h.is_timeline)
        return (
          <div
            key={index}
            onClick={() => selectCard(index, item)}
            style={{ padding: '0 16px' }}
          >
            <ProcedurePendencyCard
              variant="green"
              selected={selectedCard === index}
              title={getPendencyTitle(item)}
              description={
                item?.type === PendencyTypes.DOCTOR_COMMUNICATION &&
                item?.status === 'RESOLVED'
                  ? `Conversa encerrada por ${convertNameToTitleCase(
                      latestNonTimeline?.responsible || ''
                    )}`
                  : latestNonTimeline?.description ??
                    convertNameToTitleCase(latestNonTimeline?.responsible || '')
              }
              responsible={item?.responsible}
              createdAt={item?.createdAt}
              message={latestNonTimeline?.message || ''}
              status={'Resolvidas'}
              authorLastMessage={latestNonTimeline?.responsible}
              dateLastMessage={latestNonTimeline?.createdAt}
            />
          </div>
        )
      })}
    </S.PendenciesWrapper>
  )
}
